import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * Centered layout for standalone auth pages (register, reset password, etc.).
 */
export default function AuthPageLayout({ title, subtitle, children, footerLink }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                background: 'var(--background-color)',
                color: 'var(--text-primary)',
            }}
        >
            <Box sx={{ maxWidth: '440px', width: '100%', px: 2 }}>
                <Typography
                    variant="h5"
                    component="h1"
                    sx={{ fontWeight: 600, mb: 1.5, textAlign: 'center' }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-secondary)',
                            mb: 2.5,
                            textAlign: 'center',
                            lineHeight: 1.6,
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
                {children}
                {footerLink && (
                    <Typography
                        sx={{ mt: 2.5, textAlign: 'center', color: 'var(--text-secondary)' }}
                    >
                        <Link to={footerLink.to} style={{ color: 'var(--text-primary)' }}>
                            {footerLink.label}
                        </Link>
                    </Typography>
                )}
            </Box>
        </div>
    );
}
